import type { VisaApplicationResponse } from '../components/dashboard/admin/visa-applications/types/visa-application.types';

type Application = VisaApplicationResponse;

export const acronyms = ['mrz', 'eid', 'est', 'uae', 'gdrfa', 'hrms', 'bu'];

export const ApplicationKeys = [
  'mrz',
  'passportNumber',
  'applicationNumber',
  'visaType',
  'visaStatus',
  'visaUidNumber',
  'visaFileNumber',
  'visaIssueDate',
  'visaExpiryDate',
  'visaName',
  'visaSponsor',
  'clientName',
  'orgLevel1',
  'orgLevel2',
  'orgLevel3',
  'orgLevel4',
  'orgLevel5',
  'orgLevel6',
  'orgLevel7',
  'tradeLicenseNumber',
  'tradeLicenseIssueDate',
  'tradeLicenseExpiryDate',
  'estCardNumber',
  'estCardIssueDate',
  'estCardExpiryDate',
  'companyAddress',
  'serviceName',
  'serviceStage',
  'serviceOutcome',
  'triggerTime',
  'executionStartTime',
  'executionEndTime',
  'executionDuration',
  'documentNumber',
  'failureCategory',
  'failureDetail',
  'failureCount',
  'machineId',
  'incidentId',
  'candidateId',
  'employeeId',
  'probotId',
  'employmentStartDateEstimate',
  'employmentStartDateActual',
  'employmentEndDate',
  'addressHome',
  'addressLocal',
  'phoneHome',
  'educationLevel',
  'educationDescription',
  'maritalStatus',
  'firstLanguage',
  'numberOfChildren',
  'motherName',
  'fatherName',
  'typedFirstName',
  'typedMiddleName',
  'typedLastName',
  'typedDateOfBirth',
  'typedGender',
  'typedNationality',
  'biodataVerified',
  'companyDesignation',
  'mappedDesignation',
  'workType',
  'previousNationality',
  'askingForAddressInUae',
  'askingForMobileNumber',
  'passportFirstName',
  'passportMiddleName',
  'passportLastName',
  'passportIssueDate',
  'passportExpiryDate',
  'passportDateOfBirth',
  'passportGender',
  'passportNationality',
  'passportIssuingAuthority',
  'passportIssuingCountry',
  'passportPlaceOfBirth',
  'eidFirstName',
  'eidMiddleName',
  'eidLastName',
  'eidNumber',
  'eidIssueDate',
  'eidExpiryDate',
  'eidDateOfBirth',
  'eidGender',
  'eidNationality',
  'eidPlaceIssued',
  'eidOccupation',
  'eidCardNumber',
  'visaEmirate',
  'visaDesignation',
  'dlFullName',
  'dlCategory1',
  'dlCategory2',
  'dlNumber',
  'dlIssueDate',
  'dlExpiryDate',
  'dlDateOfBirth',
  'dlPlaceIssued',
  'noticePeriod',
  'probationPeriod',
  'restDays',
  'basicSalaryAmount',
  'basicSalaryFrequency',
  'housingAmount',
  'housingFrequency',
  'housingProvidedByCompany',
  'transportAllowanceAmount',
  'transportAllowanceFrequency',
  'otherAllowanceAmount',
  'otherAllowanceFrequency',
  'childrenSchoolAllowanceAmount',
  'telephoneAllowanceAmount',
  'telephoneAllowanceFrequency',
  'ticketAllowanceAmount',
  'ticketAllowanceFrequency',
  'commissionAmount',
  'commissionFrequency',
  'recruiterName',
  'recruiterEmail',
  'recruiterTelephone',
  'religionCode',
  'religionName',
  'sectCode',
  'sectName',
  'applicationStatus',
  'applicationType',
  'applicationCost',
  'createdTimestamp',
  'statusTimestamp',
  'profCode',
  'profContract',
  'profGdrfa',
  'profGdrfaCode',
  'profHrms',
  'profPreferred',
  'profBu',
  'deptCode',
  'airlineName',
  'flightNumber',
  'departureAirport',
  'arrivalAirport',
  'arrivalDate',
  'arrivalTime',
  'bookingRef',
  'lastUpdated',
  'updatedBy',
  'incidentNumber',
  'subject',
  'description',
  'requesterOrganisation',
  'requesterName',
  'requesterEmail',
  'requesterPhone',
  'status',
  'probotId',
  'clientPriority',
  'probotPriority',
  'assignedTo',
  'relatedServiceCode',
  'resolutionSummary',
  'approvalStatus',
  'escalationLevel',
  'attachments',
  'feedbackRating',
  'rootCauseCategory',
  'linkedTickets',
  'automationFlag',
  'openTimestamp',
  'lastUpdateTimestamp',
  'closedTimestamp',
  'timeToFirstResponse',
  'timeToResolution',
] as (keyof Application)[];
